import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { NotificationService } from '../../../../services/notification.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'app-change-notification-settings',
  standalone: true,
   imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './change-notification-settings.component.html',
  styleUrl: './change-notification-settings.component.css'
})
export class ChangeNotificationSettingsComponent {


  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  contractList: any;
  monthDropdown: any;
  yearDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  monthList: number[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  dashboard_msg: string | null = null;
  msgType: string | null = null;
  selectAll = false;

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, private ns: NotificationService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
     this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.contract');
    if (isPlatformBrowser(this.platformId)) {
      this.selectedYear = new Date().getFullYear();
      this.selectedMonth = 6;//new Date().getMonth();
      this.getYear();
      this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
    }
  }
  ngAfterViewInit(): void {
    // 
  }
  getYear() {
    this.ns.getYearList()
      .subscribe({
        next: (resYearList: any) => {
          this.yearDropdown = resYearList.data;
          this.getNotificationtList();
          // this.getAssociatesList('2025-07-01');
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
			return	
          }
        }
      });
  }

  getNotificationtList() {
    const dateFormat = this.selectedYear + "-" + this.selectedMonth;
    this.ns.getAssociates(dateFormat)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.contractList = res.data;
             this.contractList = res.data.map((item: any) => ({
                ...item,
                // sections: item.section.map((sec: any) => ({
                //   ...sec                    
                // }))              
             }));
            console.log(this.contractList);
            this.totalCount = this.contractList.length;
            this.updateVisibleData();
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          } else {

          }
        }
    })
  }

  fncCng(event: any, dateType: any) {
      // let dateFormat = this.getDateFromEvent(event);
      let date = event.target.value;
      if (dateType == 'year') {
        this.selectedYear = date;
      } else if (dateType == 'month') {
        this.selectedMonth = date;
      }
      this.getNotificationtList();
    }
  
    applyFilterGlobal($event: Event) {
      const input = $event.target as HTMLInputElement;
      this.dt2.filterGlobal(input.value, 'contains');
      // Table triggers onFilter after this
    }
  
    // Update filteredData whenever filter or pagination changes
    onFilter(event: any) {
      this.updateVisibleData();
    }
  
    onPage(event: any) {
      this.updateVisibleData(event);
    }
  
    onSort() {
      this.updateVisibleData();
    }
  
    updateVisibleData(event?: any) {
      const filtered = this.dt2.filteredValue ?? this.contractList??[];
      const start = event?.first ?? this.dt2.first ?? 0;
      const rows = event?.rows ?? this.dt2.rows ?? 3;
      const end = start + rows;
      this.visibleData = filtered.slice(start, end);
    }
  
    onGlobalFilter(event: Event) {
      const value = (event.target as HTMLInputElement).value;
      this.dt2.filterGlobal(value, 'contains');
    }
  
    applyEncryption(dt: any) {
      dt.forEach((elm: any, ind: any) => {
        dt[ind].timesheetID = Base64UrlService.encode(this.en.encryptionAES(elm.timesheetID.toString()))
      });
      return dt;
    }
    
  toggleAllApprovals(event: Event) {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;
    
    this.selectAll = isChecked; // update header state
    
    // Update all rows
    const payLoad: any[] = this.contractList.map((item: any) => {
      item.emailNotification = isChecked;
      return {
        userId: item.userId,
        emailNotification: isChecked
      };
    });

    this.updateEmailNotification(payLoad);
  }

  onRowApproveChange() {
    this.selectAll = this.contractList.every((item: any) => item.emailNotification);
  }

  emailNotification(event: any,userId: any) {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;
    let flag = true;
    if (!isChecked) {
      flag = false;
    }
    const payLoad = [{
      userId: userId,
      emailNotification: flag
    }]
    // console.log(payLoad); 
    // return
    this.updateEmailNotification(payLoad);
  }

  updateEmailNotification(payLoad: any) {
    this.ns.sendEmailNotification(payLoad)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            this.getNotificationtList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "danger";
            this.getNotificationtList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          } else {
            this.dashboard_msg = "dataSaveErrorMessage";
            this.msgType = "danger";
            this.getNotificationtList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      });
  }

  reset() {
    this.dashboard_msg = null;
  }

}
